import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/faqs";
import { SectionHead, Reveal } from "@/components/ui/motion";

export const FaqList = ({ items = FAQS }) => (
  <Accordion type="single" collapsible className="border-t border-line" data-testid="faq-accordion">
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`f-${i}`} className="border-b border-line">
        <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-semibold text-slateb hover:text-accentb hover:no-underline sm:text-xl">
          <span className="flex gap-5"><span className="pt-1 text-sm font-bold text-accentb">{String(i + 1).padStart(2, "0")}</span>{f.q}</span>
        </AccordionTrigger>
        <AccordionContent className="pb-6 pl-10 pr-4 text-[15.5px] leading-relaxed text-ink">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const FaqSection = () => (
  <section className="bg-white pb-20 sm:pb-28 lg:pb-36" data-testid="faq-section">
    <div className="wrap grid grid-cols-1 gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <SectionHead eyebrow="FAQ" title={<>Pertanyaan yang <span className="serif-it font-normal text-accentb">sering</span> diajukan.</>} />
        <Reveal delay={0.1}><Link to="/faq" className="link-u mt-8 inline-block text-sm font-semibold text-slateb" data-testid="faq-see-all">Lihat semua pertanyaan →</Link></Reveal>
      </div>
      <Reveal className="lg:col-span-8"><FaqList items={FAQS.slice(0, 7)} /></Reveal>
    </div>
  </section>
);
